import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { IWelcomeScreenState } from './welcome_screen.reducer';
import * as fromReducer from './welcome_screen.reducer';

const getHideWelcomeScreenState = createFeatureSelector<IWelcomeScreenState>('hideWelcomeScreen');

export const getHideWelcomeScreen = createSelector(
  getHideWelcomeScreenState,
  fromReducer.getHideWelcomeScreen
);
export const getHideWelcomeScreenActionState = createSelector(
  getHideWelcomeScreenState,
  fromReducer.getHideWelcomeScreenActionState
);
